export default __webpack_public_path__ + "static/media/Partner-Cpotential.89cd5a2a.png";